export default __webpack_public_path__ + "static/media/hemp-shoes.4bc39c07.jpeg";